import React from 'react';
import { FileQuestion, ArrowLeft } from 'lucide-react';
import { useNavigate } from '../../routes';
import { ROUTES } from '@repo/shared-types/routeRegistry';

export const NotFoundView: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <FileQuestion size={64} className="text-slate-400 dark:text-slate-500 mb-4" />
      <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">Page not found</h1>
      <p className="text-slate-600 dark:text-slate-400 mb-6 max-w-md">
        The page you’re looking for doesn’t exist or has been moved.
      </p>
      <button
        type="button"
        onClick={() => navigate(ROUTES.APP)}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-brand-600 text-white hover:bg-brand-700 transition"
      >
        <ArrowLeft size={18} />
        Back to Dashboard
      </button>
    </div>
  );
};

